import { getDoc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import PlusIcon from '../../../components/UI/Icon-SVG/PlusIcon';
import ProfileIconSmall from '../../../components/UI/Icon-SVG/ProfileIconSmall';
import { Context } from '../../../index';

const Container = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-left: 1px solid #d7def3;
  padding: 20px 16px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  margin: 0;
`;

const MembersHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 16px;
  margin-bottom: 26px;
`;

const MemberCount = styled.p`
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  margin: 0 70px 0 0;
`;

const Img = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
`;

const Plus = styled.div`
  width: 32px;
  height: 32px;
  background: #397ef3;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: not-allowed;
`;

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  background: #397ef3;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

const UserName = styled.p`
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  margin: 0 0 0 12px;
`;

const GroupInfo = ({ groupUsers, userId }) => {
  const history = useHistory();
  const { firestore } = useContext(Context);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    groupUsers?.forEach((item, i) => {
      getDoc(
        firestore
          .collection(item.is_lawyer ? 'lawyer_full_profile' : 'user_full_profile')
          .doc(item.firebase_uid),
      ).then((data) => {
        users.push({
          id: data.id,
          data: data.data(),
        });
        if (groupUsers.length - 1 === i) {
          setUsers([...users]);
        }
      });
    });
  }, [groupUsers?.length]);

  const renderItem = (item, index) => {
    const handleAvatarClick = () => {
      userId !== item.firebase_uid && history.push(`/profile/${item.firebase_uid}`);
    };

    const name =
      item.first_name && item.last_name ? `${item.first_name} ${item.last_name}` : 'Unnamed';

    const user = users?.find((el) => el.id === item.firebase_uid);

    return (
      <Item key={index}>
        <Avatar onClick={handleAvatarClick}>
          {user?.data?.avatar?.avatar_path ? (
            <Img src={user.data.avatar.avatar_path} alt="av" />
          ) : (
            <ProfileIconSmall />
          )}
        </Avatar>
        <UserName>{name}</UserName>
      </Item>
    );
  };

  return (
    <Container>
      <Title>Group Info</Title>
      <MembersHeader>
        <MemberCount>{groupUsers?.length} Members</MemberCount>
        <Plus>
          <PlusIcon />
        </Plus>
      </MembersHeader>
      {groupUsers?.map(renderItem)}
    </Container>
  );
};

export default GroupInfo;
